jQuery(function ($) {
	function cookieLegalCheck(setcookie){
		var data = {
			action : 'ajax_legal_notice',
			setcookie : setcookie,
		};

	    $.ajax({
	        type : 'post',
	       	url : legal_notice_ajax_url.ajaxurl,
	        data : data,
	        success : function( response ) {
			   if(response.prcookie){
			   		$('#legal_notice_prompt').fadeOut();
			   }else{
			   		$('#legal_notice_prompt').fadeIn();
			   		$('#certify').click(function(e){
		   				e.preventDefault();
		   				// cookieLegalCheck(1);
		   				cookie.set('__pr_legal', 1, {
	   					   expires: 7, // Expires in 999 days
	   					   path: '/',
	   					});
	   					$('#legal_notice_prompt').fadeOut();
		   			});
			   }

	        }
	    });
	}

	if(!cookie.get('__pr_legal'))
		cookieLegalCheck(0);
});
